const {
  blockEditor: { InnerBlocks, useBlockProps },
} = wp;

export default function save() {
  const blockProps = useBlockProps.save();
  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
}
